import { Phone } from 'lucide-react';
import './FloatingButtons.css';

const FloatingCallButton = () => {
    return (
        <a
            href="tel:+919640888898"
            className="floating-call-button"
            aria-label="Call us"
            title="Call us at +91 96408 88898"
        >
            <Phone size={28} />
        </a>
    );
};

export default FloatingCallButton;
